module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExClosable,
      "code": _vm.ExClosableCode,
      "title": "Closable",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTaglist,
      "code": _vm.ExTaglistCode,
      "title": "Tag list",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTaglistAttached,
      "code": _vm.ExTaglistAttachedCode,
      "vertical": ""
    }
  }, [_c('p', [_vm._v("Use the "), _c('code', [_vm._v("attached")]), _vm._v(" prop to attach tags together.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExFieldCombine,
      "code": _vm.ExFieldCombineCode,
      "vertical": ""
    }
  }, [_c('p', [_vm._v("Combine with field to group attached tags.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSizes,
      "code": _vm.ExSizesCode,
      "title": "Sizes",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("Two additional sizes.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("Closable tags have a button that can be focused, it emits a "), _c('code', [_vm._v("close")]), _vm._v(" event when clicked or when "), _c('b', [_vm._v("delete")]), _vm._v(" key is pressed.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-badbf2ba"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/tag/Tag.vue
// module id = 1546
// module chunks = 16